import { cn, modulo } from "@/lib/utils";
import { ComponentProps } from "react";

const patterns = import.meta.glob('/src/assets/patterns/**/*.svg', { eager: true })

const PATTERN_COUNT = 10;

type Props = {
  pattern: number;
  // Between 0-100
  opacity?: number;
} & ComponentProps<"div">


// <div
//   className={cn("bg-no-repeat bg-cover bg-center relative", className)}
//   style={{
//     backgroundImage: `url("${((patterns[`/src/assets/patterns/red/${modulo(pattern, PATTERN_COUNT)}.svg`] as { default?: unknown })?.default as string) ?? ""}")`
//
//   }}
//   {...props}
// >

export const PatternBackground = ({ pattern, opacity = 100, className, children, ...props }: Props) => {
  return (
    <div
      className={cn("relative", className)}
      {...props}
    >
      <div className="overflow-hidden absolute top-0 left-0 w-full h-full">
        <img src={((patterns[`/src/assets/patterns/red/${modulo(pattern, PATTERN_COUNT)}.svg`] as { default?: unknown })?.default as string) ?? ""} className="w-full h-full object-cover object-center" style={{ opacity: `${opacity}%` }} />
      </div>
      <div className="z-10 relative">
        {children}
      </div>
    </div>
  )
}
